<template>
  <div>
    <div>
      <f7-block-title
        v-if="mostrarTitulo"
        class="block-titleColor"
      >
        {{ $t('production.locations.palletStock.title') }}
      </f7-block-title>
      <!-- Preloader de carga -->
      <UCPreload :show="mostrarPrecarga" />
      <!-- Existen existencias en el palé -->
      <div class="div-registrosExistencias">
        <div
          v-for="existencia in existencias"
          :key="existencia.Id"
          class="div-registroExistencia"
          :class="{ 'row-seleccionada': existencia.Seleccionado }"
        >
          <f7-row v-if="existencia.Articulo.TipoArticulo === 'Producto'">
            <f7-col width="100">
              <f7-row>
                <f7-col
                  width="40"
                  class="col-productoExistencia"
                >
                  <span
                    v-if="ObtenerTipoPaleExistencia(existencia) != null"
                    class="span-texto-gris-1"
                  >{{ FormatearCadena(ObtenerTipoPaleExistencia(existencia).Articulo.Nombre, 15) }} </span>
                </f7-col>
                <f7-col
                  width="60"
                  class="col-productoExistencia"
                >
                  <span
                    v-if="existencia.Lote != null && existencia.Lote.Id !== 0"
                    class="span-texto-gris-1"
                  >
                    {{ `${$t('common.lot').toUpperCase()} ${FormatearCadena(existencia.Lote.Codigo, 18)}` }}
                  </span>
                </f7-col>
              </f7-row>
              <f7-row>
                <f7-col
                  width="100"
                  class="col-productoExistencia"
                >
                  <span class="span-texto-teal-3">{{ FormatearCadena(existencia.Articulo.Nombre, 27) }} </span>
                </f7-col>
              </f7-row>
              <f7-row>
                <f7-col
                  width="100"
                  class="col-partidas"
                >
                  <div>
                    <!-- <span class="span-texto-amarillo-16-600" v-if="existencia.Ubicacion != null"> {{ FormatearCadena(existencia.Ubicacion.Nombre, 27) }} </span> -->
                    <span
                      v-if="ubicacion != null"
                      class="span-texto-amarillo-16-600"
                    > {{ FormatearCadena(ubicacion.Nombre, 27) }} </span>
                  </div>
                </f7-col>
              </f7-row>
              <f7-row class="row-volcadoFamilia">
                <f7-col
                  class="div-cantidadEnvases"
                  width="50"
                >
                  <img
                    alt="iconBox"
                    src="@/static/icons/ic_box.svg"
                  >
                  <span class="span-cantidadEnvases"> {{ ObtenerCantidEnvasesExistencia(existencia) }} </span>
                </f7-col>
                <f7-col
                  width="50"
                  class="div-cantidadKilos"
                >
                  <span class="span-cantidadKilos"> {{ existencia.Cantidad }} </span>
                  <span class="span-unidadMedidaKilos"> {{ $t('common.kg') }} </span>
                </f7-col>
              </f7-row>
            </f7-col>
          </f7-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import SoporteCadena from '@/js/common/HiChainSupport';
import UCPreload from '@/components/common/UCPreload.vue';

export default {
  name: 'PCExistenciasDeUnPalePrecalibradoConInformacionDeUbicaciones',
  components: {
    UCPreload,
  },
  props: {
    mostrarTitulo: { type: Boolean, default: false },
    listadoExistencias: { type: Array, default: () => [] }, // Recibe la lista de existencias y la carga.
    ubicacion: { type: Object, default: null },
  },
  data() {
    return {
      existencias: null,
      mostrarPrecarga: false, // Muestra el componente de precarga
    };
  },
  watch: {
    listadoExistencias(val) {
      if (val != null) {
        this.existencias = this.listadoExistencias;
      }
    },
  },
  created() {
    this.InicializarComponente();
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.existencias = this.listadoExistencias; // Existencias recibidad por el componente
    },

    ObtenerCantidEnvasesExistencia(existenciaProducto) {
      Log(this, this.ObtenerCantidEnvasesExistencia.name);
      const existenciasDeTipoEnvaseDelProducto = this.existencias.filter((e) => (e.Articulo.TipoArticulo === 'Envase') && (e.Partida.Id === existenciaProducto.Partida.Id))[0];
      if (existenciasDeTipoEnvaseDelProducto === undefined) {
        return 0;
      } // Hay un error y no hay existencia de tipo envase en el palé para el producto
      return existenciasDeTipoEnvaseDelProducto.Cantidad;
    },

    /** NOTA: Una UL puede tener varios pales, Ej: Uno abajo y otro en la parte intermedia */
    ObtenerTipoPaleExistencia() {
      Log(this, this.ObtenerTipoPaleExistencia.name);
      const existenciasDeTipoPale = this.existencias.filter((e) => (e.Articulo.TipoArticulo === 'Palet'))[0];
      if (existenciasDeTipoPale === undefined) {
        return null;
      } // No hay existencia de tipo palé
      return existenciasDeTipoPale;
    },

    FormatearCadena(cadena, longitudMaxima) {
      Log(this, this.FormatearCadena.name);
      return SoporteCadena.TextoLogitudMaxima(cadena, longitudMaxima);
    },
  },

};
</script>

<style scoped>
.div-registrosExistencias {
  margin-top: 25px;
}

.div-registroExistencia {
  margin-left: 25px;
  padding-right: 20px;
  padding-top: 10px;

  /*     padding-bottom: 10px;
    margin-top: 15px;
    border-bottom: 1px solid var(--his-disabled); */
}

.col-col-productoExistencia {
  font-size: 16px;
  font-weight: 500;
  line-height: 17px;
  color: #009ba6;
  padding-top: 7px;
  padding-bottom: 7px;
}

.col-opciones {
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  color: var(--his-darkgray);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70px;
}

.col-envasesYKilos {
  padding-bottom: 10px;
}

.col-partidas {
  margin-bottom: 5px;
}

.span-cantidadKilos {
  color: var(--his-darkgray);
  font-size: 22px;
  font-weight: 900;
}

.span-unidadMedidaKilos {
  color: #4a4a4a9c;
}

.div-cantidadKilos {
  text-align: right;
  padding-right: 25px;
}

.span-cantidadEnvases {
  color: var(--his-darkgray);
  font-size: 18px;
  font-weight: 500;
  font-weight: bold;
  margin-left: 10px;
}
</style>
